import PropTypes from 'prop-types'
import { motion } from 'framer-motion'

import DDIcon from '../../icons/DDIcon'
import { useReducedMotionPreference, DURATION } from '../../../styles/motion'
import styles from './Button.module.css'

const VARIANT_CLASS = {
  primary: styles.primary,
  soft: styles.soft,
  link: styles.link,
  'brand-link': styles.brandLink,
}

const SPINNER_COLOR = {
  primary: 'var(--dd-color-surface)',
  soft: 'var(--dd-color-brand)',
}

// Spec §5.1 — Primary/Soft are full-width 48px chrome buttons with tap feedback (scale .98,
// 120ms); Link/Brand link are inline text with no chrome and no tap animation.
const Button = ({ variant, loading, disabled, children, onClick, type, className }) => {
  const reduceMotion = useReducedMotionPreference()
  const isChrome = variant === 'primary' || variant === 'soft'
  const classes = [styles.base, VARIANT_CLASS[variant], className].filter(Boolean).join(' ')

  const content = (
    <>
      {loading && (
        <DDIcon name='spinner' size={18} color={SPINNER_COLOR[variant]} className={styles.spinner} />
      )}
      {children}
    </>
  )

  if (!isChrome) {
    return (
      <button type={type} className={classes} onClick={onClick} disabled={disabled || loading}>
        {content}
      </button>
    )
  }

  return (
    <motion.button
      type={type}
      className={classes}
      onClick={onClick}
      disabled={disabled || loading}
      whileTap={reduceMotion ? undefined : { scale: 0.98 }}
      transition={{ duration: DURATION.buttonPress }}
    >
      {content}
    </motion.button>
  )
}

Button.propTypes = {
  variant: PropTypes.oneOf(['primary', 'soft', 'link', 'brand-link']),
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func,
  type: PropTypes.oneOf(['button', 'submit']),
  className: PropTypes.string,
}

Button.defaultProps = {
  variant: 'primary',
  loading: false,
  disabled: false,
  type: 'button',
}

export default Button
